define('LNRS/Components/Social/SocialLinkedin',["jquery", "eventManager"], function ($, eventManager) {
    function SocialLinkedin(scope) {
        eventManager.subscribe("SiteSharingDataLoaded", function (socailSharingData) {
            var fullUrl = '';
            $.each(socailSharingData, function (index, socialNetworkData) {
                if (socialNetworkData.Name.indexOf('LinkedIn') != -1) {
                    fullUrl = socialNetworkData.FullUrl;
                }
            });
            if (fullUrl.length > 0) {
                $('#social-share-linkedin-link').attr('onclick', fullUrl);
            }
        }.bind(this));
    }

    return function init(args) {
        return new SocialLinkedin(args.scope);
    };
});
